import React, { useContext, useEffect, useState } from 'react';
import "./style.scss";
import PropTypes from 'prop-types';
import { FlowDetailsContext } from '../../../../../../../../providers/flowDetails-provider';
import { FilterContext } from '../../../../../../../../providers/filterData-provider';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useFetch } from '../../../../../../../../hooks';

const FlowList = () => {
    const [flowList, setFlowList] = useState([]);
    const { setCardData, setFlowDetails } = useContext(FlowDetailsContext);
    const { selectedLendFilterValues } = useContext(FilterContext);
    const [selctedItemIndex, setSelctedItemIndex] = useState(null);
    const lendFilterList = useSelector(state => state?.lendFilter?.data);

    const { api } = useFetch();

    const filterData = Object.keys(selectedLendFilterValues)?.map(key => {
        const filterConfig = lendFilterList?.find(ele => ele?.FILTER_ID === key);

        if (key === 'from' || key === 'to') {
            const dateFilterData = lendFilterList?.find(ele => ele?.DISPLAY_TYPE === 'DATE_PICKER');
            if (dateFilterData) {
                return {
                    id: `${dateFilterData.BASE_TABLE}.${dateFilterData.BASE_COLUMN}`,
                    datatype: 'DATE',
                    value: {
                        from: selectedLendFilterValues.from,
                        to: selectedLendFilterValues.to
                    }
                }
            }
        } else if (filterConfig) {
            const filterValues = Array.isArray(selectedLendFilterValues[key])
                ? selectedLendFilterValues[key] : [selectedLendFilterValues[key]];

            return filterValues?.map(value => ({
                id: `${filterConfig.BASE_TABLE}.${filterConfig.BASE_COLUMN}`,
                value
            }))
        }
        return null;
    }).flat().filter(Boolean);

    const fetchFlowList = async () => {
        const flowListAPI = `${process.env.REACT_APP_BASE_URL}/api/dashboard/lend/charts/flow-list`
        const payload = Object.keys(selectedLendFilterValues).length ? { filter: filterData } : { filter: [] };
        const { data } = await api(flowListAPI, 'POST', payload);
        setFlowList(data);
        handleFlowDetails(data[0]?.flowName, 0, true);
    }

    useEffect(() => {
        const cleanup = () => {
            setFlowDetails(null);
        };

        fetchFlowList();
        return cleanup;
    }, [selectedLendFilterValues]);

    const handleFlowDetails = async (flowName, index, initial = false) => {
        if (flowList && flowList.length > 0 || initial) {
            const flowDetailsAPI = `${process.env.REACT_APP_BASE_URL}/api/dashboard/lend/charts/flow-details`;
            filterData.unshift({
                id: "APPLICATION_TASKS_CONFIGS_ACTIVE.FLOW_NAME",
                value: flowName
            })
            const withoutFilter = [{ id: "APPLICATION_TASKS_CONFIGS_ACTIVE.FLOW_NAME", value: flowName }];
            const payload = Object.keys(selectedLendFilterValues).length ? { filter: filterData } : { filter: withoutFilter };
            const { data } = await api(flowDetailsAPI, 'POST', payload);
            setFlowDetails({ flowData: data });
            setCardData(null);
            setSelctedItemIndex(index);
        }
    }

    return (
        <div className='flow-details'>
            {
                flowList && flowList?.length > 0 && flowList?.map((ele, i) => {
                    const words = ele?.flowName?.split(" ");
                    const code = words?.slice(0, 2).map(word => word.charAt(0).toUpperCase()).join('');

                    return (
                        <div key={i} className={classNames('flow-details__items', { 'flow-details__items__selected': selctedItemIndex === i })} onClick={() => handleFlowDetails(ele?.flowName, i)}>
                            <p className='flow-details__items__code'>{code}</p>
                            <p>{ele?.flowName}</p>
                        </div>
                    );

                })
            }
        </div>
    )
}

export default FlowList;


FlowList.propTypes = {
    flowList: PropTypes.array
}
